import React from 'react';
import { Lock } from 'lucide-react';

export function PrivacyCallout() {
  return (
    <section className="bg-[#FEF7FF] dark:bg-m3-dark-surface border-y border-[#E7E0EC] dark:border-zinc-800 py-14 text-center">
      <div className="max-w-[1200px] mx-auto px-8">
        <div className="w-[52px] h-[52px] rounded-full bg-[#EADDFF] dark:bg-[#4F378B] flex items-center justify-center mx-auto mb-5">
          <Lock className="w-6 h-6 text-[#6750A4] dark:text-m3-dark-primary" />
        </div>
        <h2 className="text-[clamp(22px,3vw,36px)] font-extrabold tracking-[-0.03em] text-[#1D1B20] dark:text-white mb-2.5">
          Your data never leaves your phone.
        </h2>
        <p className="text-base text-[#79747E] dark:text-[#9A96A0]">
          No servers. No accounts. No tracking. Ever.
        </p>
      </div>
    </section>
  );
}
